/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  UpdateProductPageComponentsMutationRequest,
  UpdateProductPageComponentsMutationResponse,
} from "../types/UpdateProductPageComponents.ts"

export const updateProductPageComponentsMutationKey = () =>
  [{ url: "/v1/organization-settings/product-page-components" }] as const

export type UpdateProductPageComponentsMutationKey = ReturnType<
  typeof updateProductPageComponentsMutationKey
>

/**
 * @summary Update product page component content
 * {@link /v1/organization-settings/product-page-components}
 */
export async function updateProductPageComponents(
  data: UpdateProductPageComponentsMutationRequest,
  config: Partial<RequestConfig<UpdateProductPageComponentsMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateProductPageComponentsMutationResponse,
    ResponseErrorConfig<Error>,
    UpdateProductPageComponentsMutationRequest
  >({
    method: "PUT",
    url: `/v1/organization-settings/product-page-components`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function updateProductPageComponentsMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<UpdateProductPageComponentsMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = updateProductPageComponentsMutationKey()
  return mutationOptions<
    ResponseConfig<UpdateProductPageComponentsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpdateProductPageComponentsMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return updateProductPageComponents(data, config)
    },
  })
}

/**
 * @summary Update product page component content
 * {@link /v1/organization-settings/product-page-components}
 */
export function useUpdateProductPageComponents<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<UpdateProductPageComponentsMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: UpdateProductPageComponentsMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<
      RequestConfig<UpdateProductPageComponentsMutationRequest>
    > & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? updateProductPageComponentsMutationKey()

  const baseOptions = updateProductPageComponentsMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<UpdateProductPageComponentsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpdateProductPageComponentsMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<UpdateProductPageComponentsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpdateProductPageComponentsMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<UpdateProductPageComponentsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpdateProductPageComponentsMutationRequest },
    TContext
  >
}
